import React from "react";
import { CornerDownRight } from "lucide-react";
import { useAura } from "./AuraProvider";

// Tappable next questions under Simmi's latest reply (her suggest_followups tool, or offline suggestions).
const FollowUps = ({ items, className = "" }) => {
  const { send } = useAura();
  if (!items?.length) return null;
  return (
    <div className={`aura-msg flex flex-wrap gap-1.5 ${className}`} aria-label="Suggested questions">
      {items.map((q) => (
        <button
          key={q}
          type="button"
          onClick={() => send(q)}
          className="inline-flex items-center gap-1.5 rounded-full border border-[#06D3DB]/30 bg-[#06D3DB]/[0.06] px-3 py-1.5 text-left text-[12px] text-white/85 transition-colors hover:border-[#06D3DB]/70 hover:bg-[#06D3DB]/15 hover:text-white"
        >
          <CornerDownRight className="h-3 w-3 shrink-0 text-[#06D3DB]" />
          {q}
        </button>
      ))}
    </div>
  );
};

export default FollowUps;
